interface ReleaseErrorBody {
  error?: { code?: string };
}

/**
 * What the API said when a desk could not be released, in the words the
 * release prompts show. Codes come from the resource dedicated exceptions
 * endpoint.
 *
 * These say nothing about reservations. The same failure reaches flows that
 * cancelled some, flows that deliberately kept them all, and flows with none
 * to begin with, so claiming any of that here would tell most of them
 * something untrue. What every one of them can be told is that the desk was
 * not given away.
 */
export const releaseDeskErrorMessage = (result: unknown): string => {
  const code = (result as ReleaseErrorBody | null)?.error?.code;
  switch (code) {
    case "dedicated_exception_overlaps":
      return "Your desk is already released on some of these days. Change that release from the desk's settings, or pick other days.";
    case "invalid_time_range":
      return "The days to release must not end before today.";
    case "forbidden":
    case "dedicated_user_required":
      return "This desk is not dedicated to you any more.";
    default:
      return "Could not release your desk. It is still yours.";
  }
};
